import React from 'react';
import styled from '@emotion/styled';
import { cx } from '@emotion/css';

import { parseHtml } from '../helpers';

import { ComponentStyle, BulletPoint } from '../../types/types';

const Li = styled.li({
  '&.B': {
    borderColor: 'currentColor',
  },

  '&.C': {
    borderColor: 'currentColor',
  },

  '&.D': {
    borderColor: 'currentColor',
  },
});

type Props = {
  points: BulletPoint[];
  style: ComponentStyle;
};

export const BenefitsPoints: React.FC<Props> = ({ points, style }) => {
  if (!(points && points.length)) {
    return null;
  }
  return (
    <ul
      className={cx(style, 'feature', {
        tick: style === ComponentStyle.A || style === ComponentStyle.C,
        'tick-black': style === ComponentStyle.C,
      })}
      data-testid='mp-product-benefits-points'
    >
      {points?.map((point, i) => (
        <Li key={i} className={style}>
          {parseHtml(point.title)}
        </Li>
      ))}
    </ul>
  );
};
